import { message } from "antd";
import axiosInstance from "../axiosInstance";
import { PAGE_SIZE } from "../constants";

import {
	CREATE_SPIN_GAME_REQUEST,
	CREATE_SPIN_GAME_SUCCESS,
	CREATE_SPIN_GAME_FAIL,
	RESET_DELETE_SPIN_GAME,
	FETCH_SPIN_GAMES_REQUEST,
	FETCH_SPIN_GAMES_SUCCESS,
	FETCH_SPIN_GAMES_FAIL,
	UPDATE_SPIN_GAME_REQUEST,
	UPDATE_SPIN_GAME_SUCCESS,
	UPDATE_SPIN_GAME_FAIL,
	DELETE_SPIN_GAME_REQUEST,
	DELETE_SPIN_GAME_SUCCESS,
	DELETE_SPIN_GAME_FAIL,
	FETCH_SPIN_GAME_REQUEST,
	FETCH_SPIN_GAME_SUCCESS,
	FETCH_SPIN_GAME_FAIL,
} from "../constants/spinTheWheelGame";

const createSpinGame = (values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: CREATE_SPIN_GAME_REQUEST });
	try {
		const { data } = await axiosInstance.post("/admin/games", values, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});
		message.success("Created.");
		dispatch(fetchSpinGames({ start: 0, count: PAGE_SIZE }));
		dispatch({
			type: CREATE_SPIN_GAME_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: CREATE_SPIN_GAME_FAIL, payload: errorMessage });
	}
};

const fetchSpinGames = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: FETCH_SPIN_GAMES_REQUEST });
	try {
		const { data } = await axiosInstance.get("/admin/games", {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: FETCH_SPIN_GAMES_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_SPIN_GAMES_FAIL, payload: errorMessage });
	}
};

const resetDeleteStatusSpinGame = () => async (dispatch) => {
	dispatch({ type: RESET_DELETE_SPIN_GAME });
};

const updateSpinGame = (id, values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: UPDATE_SPIN_GAME_REQUEST });
	try {
		const { data } = await axiosInstance.patch(`/admin/games/${id}`, values, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		message.success("Updated.");
		dispatch({
			type: UPDATE_SPIN_GAME_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: UPDATE_SPIN_GAME_FAIL, payload: errorMessage });
	}
};

const deleteSpinGame = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: DELETE_SPIN_GAME_REQUEST });
	try {
		const { data } = await axiosInstance.delete(`/admin/games/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		message.success("Deleted.");
		dispatch({
			type: DELETE_SPIN_GAME_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: DELETE_SPIN_GAME_FAIL, payload: errorMessage });
	}
};

const fetchSpinGame = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: FETCH_SPIN_GAME_REQUEST });

	try {
		const { data } = await axiosInstance.get(`/admin/games/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});
		console.log("data ", data.data);
		dispatch({ type: FETCH_SPIN_GAME_SUCCESS, payload: data.data });
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: FETCH_SPIN_GAME_FAIL, payload: errorMessage });
	}
};

export {
	createSpinGame,
	resetDeleteStatusSpinGame,
	fetchSpinGames,
	updateSpinGame,
	deleteSpinGame,
	fetchSpinGame,
};
